"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ContactPerson = /*#__PURE__*/function () {
  function ContactPerson(opt) {
    _classCallCheck(this, ContactPerson);

    this.userId = null;
    this.firstName = null;
    this.lastName = null;
    this.email = null;
    this.phoneNumber = null;

    if (opt) {
      this.fillObject(opt);
    }
  }

  _createClass(ContactPerson, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this.userId = opt.userId || null;
      this.firstName = opt.firstName || null;
      this.lastName = opt.lastName || null;
      this.email = opt.email || null;
      this.phoneNumber = opt.phoneNumber || null;
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'contact-person.schema.json',
        type: 'object',
        additionalProperties: false,
        properties: {
          userId: {
            type: 'string'
          },
          firstName: {
            type: ['string', 'null']
          },
          lastName: {
            type: ['string', 'null']
          },
          email: {
            type: ['string', 'null']
          },
          phoneNumber: {
            type: ['string', 'null']
          }
        },
        required: Object.keys(this)
      };
    }
  }]);

  return ContactPerson;
}();

module.exports = ContactPerson;